import React from "react";
import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Tooltip } from "@rentablo/components";
import { getChartHeights } from "./utils";

const ChartContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
`;

const BarsContainer = styled(Box)`
  display: flex;
  align-items: flex-end;
  height: 105px;
  gap: 18px;
  margin-bottom: 16px;
`;

const Bar = styled(Box)<{
  height: number;
  color: string;
}>`
  width: 30px;
  height: ${(props) => `${props.height}%`};
  background-color: ${(props) => props.color};
  border-radius: 2px;
`;

const Label = styled(Box)`
  margin-top: 12px;
  font-size: 14px;
`;

interface MiniBarChartProps {
  value1: number;
  value2: number;
  color1?: string;
  color2?: string;
  label: string;
  className?: string;
}

export const MiniBarChart = ({
  value1,
  value2,
  color1 = "#A399F2",
  color2 = "#41D8A3",
  label,
  className,
}: MiniBarChartProps) => {
  const { t } = useTranslation();
  const { height1, height2 } = getChartHeights(value1, value2);

  return (
    <ChartContainer className={className}>
      <BarsContainer>
        <Tooltip text={value1}>
          <Bar height={height1} color={color1} />
        </Tooltip>
        <Tooltip text={value2}>
          <Bar height={height2} color={color2} />
        </Tooltip>
      </BarsContainer>
      <Typography variant="body1" fontWeight={600} textAlign="center">
        {t(label)}
      </Typography>
    </ChartContainer>
  );
};
